import { Component, OnInit } from '@angular/core';
import { AuthorizationFrontendService } from '../../services/authorizationfrontend.service';
import { Router, UrlTree } from '@angular/router';

@Component({
    selector: 'authorizationfrontend-callback-logout',
    templateUrl: './authorizationfrontend-callback-logout.component.html',
})
export class AuthorizationFrontendCallbackLogoutComponent implements OnInit {
    constructor(
        private m_Router: Router,
        private m_AuthorizationService: AuthorizationFrontendService) {
    }

    ngOnInit(): void {
        let state: string | null = null;

        let urlTree: UrlTree = this.m_Router.parseUrl(this.m_Router.url);

        if (urlTree.queryParamMap.has('state')) {
            // fourni comme paramètres
            state = urlTree.queryParamMap.get('state');
        }

        this.m_AuthorizationService.redirectToLogin(state ?? "");
    }

}
